import { render, staticRenderFns } from "./Nft_details.vue?vue&type=template&id=2b87efde&scoped=true&"
import script from "./Nft_details.vue?vue&type=script&lang=js&"
export * from "./Nft_details.vue?vue&type=script&lang=js&"
import style0 from "./Nft_details.vue?vue&type=style&index=0&id=2b87efde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87efde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
